import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Footer } from "@/components/Footer";
import { useSeo } from "@/lib/useSeo";
import { ArrowLeft, Lock, Coins, KeySquare, Sparkles } from "lucide-react";

export default function ComeFunziona() {
  useSeo({
    title: "Come Funziona — SuiteCrowd",
    description:
      "Come funziona SuiteCrowd: co-finanzia un hotel 5 stelle in ristrutturazione con una quota simbolica, ricevi un voucher soggiorno futuro, fondi protetti in escrow.",
    canonical: "https://suitecrowd.com/come-funziona",
  });

  const steps = [
    { n: "01", icon: KeySquare, t: "Entra nel club", d: "Iscriviti alla waitlist con la tua email. Il tuo posto in coda è personale, invita amici per scalare la classifica." },
    { n: "02", icon: Coins, t: "Scegli il progetto", d: "Sfoglia gli hotel 5 stelle in fase di ristrutturazione. Ogni scheda mostra target, avanzamento e giorni rimasti." },
    { n: "03", icon: Lock, t: "Co-finanzia in escrow", d: "Versa la quota di 49€. I fondi restano congelati in conto di garanzia gestito da Stripe. Zero rischi speculativi." },
    { n: "04", icon: Sparkles, t: "Ricevi il voucher", d: "A ristrutturazione completata, ricevi un voucher per 4 giorni in camera doppia — bassa/media stagione dell'anno solare successivo." },
  ];

  return (
    <div className="min-h-screen bg-white text-[#121212]">
      <nav className="border-b border-[#E5E5E5] bg-white/80 backdrop-blur-md sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex justify-between items-center">
          <Logo variant="dark" size="md" />
          <Link
            to="/"
            data-testid="back-to-home"
            className="text-[11px] tracking-[0.24em] uppercase text-neutral-500 hover:text-[#121212] inline-flex items-center gap-2 transition-colors"
          >
            <ArrowLeft size={14} /> Home
          </Link>
        </div>
      </nav>

      <section className="max-w-4xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="sc-overline mb-6">Il metodo</div>
        <h1
          data-testid="how-title"
          className="font-display font-light text-5xl md:text-6xl mb-8"
          style={{ letterSpacing: "-0.03em" }}
        >
          Come funziona SuiteCrowd
        </h1>
        <p className="text-neutral-600 text-lg leading-relaxed max-w-2xl mb-20">
          Un modello di co-finanziamento trasparente: partecipi alla rinascita di
          strutture ricettive di prestigio con una quota simbolica e ricevi in
          cambio un soggiorno futuro garantito. Non è un investimento speculativo,
          non è uno sconto: è accesso privilegiato al lusso di domani.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14">
          {steps.map(({ n, icon: Icon, t, d }, i) => (
            <div key={i} data-testid={`step-${i}`} className="space-y-4">
              <div className="flex items-center gap-4">
                <Icon size={22} className="text-[#0B192C]" strokeWidth={1.2} />
                <span className="sc-overline">{n}</span>
              </div>
              <h3 className="font-display font-normal text-2xl" style={{ letterSpacing: "-0.02em" }}>
                {t}
              </h3>
              <p className="text-sm text-neutral-600 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>

        <div className="mt-24 pt-16 border-t border-[#E5E5E5] grid grid-cols-1 md:grid-cols-3 gap-10">
          {[
            { t: "Trasparenza", d: "Ogni progetto pubblica avanzamento della raccolta e stato dei lavori certificato." },
            { t: "Sicurezza", d: "Fondi svincolati solo al target o all'avanzamento. Rimborso al 100% se il progetto non si completa." },
            { t: "Accesso", d: "Il voucher è personale, cedibile solo su approvazione. La tua posizione in coda determina la priorità." },
          ].map((v, i) => (
            <div key={i} className="space-y-3">
              <div className="sc-overline">{`0${i + 5}`}</div>
              <h4 className="font-display font-normal text-lg">{v.t}</h4>
              <p className="text-sm text-neutral-600 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-24 flex flex-col md:flex-row gap-4">
          <Link to="/" className="sc-btn-primary" data-testid="cta-waitlist">
            Entra nella waitlist
          </Link>
          <Link to="/hotel-pilota" className="sc-btn-ghost" data-testid="cta-view-pilot">
            Vedi il progetto pilota
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
